/*
 * @Author: Teemo Ding
 * @Date: 2021-08-06 09:29:37
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2022-06-15 10:49:12
 * @FilePath: /unifyxp-v2-store-portal/src/pages/CustomerDatabaseConfig/CustomerDetails/SubscriberInformation/index.tsx
 */
import { Button } from '@/src/components/Antd';
import SectionWrapper from '@/src/components/Layouts/Section/SectionWrapper';
import {
  request_info,
  request_saveCustomerInfo,
} from '@/src/request/customer/customerDetail';
import _ from 'lodash';
import React, { useState } from 'react';
import { useParams } from 'react-router';
import AreaCodeDisplay from 'src/constrains/AreaCodeDisplay';
import { useI18n } from 'src/hooks/useRouterChange';
import { isUserValid, storeResourceNameGenerator } from 'src/tools/getUserInfo';
import { i18nGet } from 'src/tools/tools';
import { EnumFieldType } from 'src/types/common/customerDb';
import {
  EPermissionSource,
  EnumCategory,
  EnumOperation,
  EnumSubCategory,
} from 'src/types/common/resources';
import CustomerInfoModal from '../../Components/CustomerInfoModal';
import VisibilityToggle from 'src/components/VisibilityToggle';
import { FiledNameKeyMapping, OptionKeyMapping } from '../../config';
import { maskPhone } from '@/src/tools/mask';
import { fieldValueGenerator } from '../../CustomerList/tools';
import css from '../css.module.less';

const permissions = () => {
  const edit_customer_info = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Customers,
        subCategory: EnumSubCategory.CustomerDetailsPage,
        operation: EnumOperation.edit_customer_info,
      }),
    ],
  });
  return {
    edit_customer_info,
  };
};
const SubscriberInformation = ({
  setShowModal,
  setModalTitle,
  setModalContent,
  customerInfoFields,
  parameterType,
  reloadData,
  fullNameAutoPopulate,
}) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { edit_customer_info } = permissions();
  const params: any = useParams();
  const { customerDatabaseUuid, customerUuid } = params;
  const [show, setShow] = useState(false);
  const saveCustomerInfo = (data) => {
    const saveData = {} as any;
    saveData.uuid = customerUuid;

    if (parameterType == 'Subscriber') {
      saveData.fields = data;
      saveData.customerDatabase = { uuid: customerDatabaseUuid };
      return request_info(saveData).then((res) => {
        return {
          response: res,
          cb: () => {
            setShowModal(false);
            reloadData('Information');
          },
        };
      });
    } else {
      saveData.customerDBUuid = customerDatabaseUuid;
      saveData.customerInfoFields = data;
      return request_saveCustomerInfo(saveData).then((res) => {
        return {
          response: res,
          cb: () => {
            setShowModal(false);
            reloadData('Information');
          },
        };
      });
    }
  };

  const editInformation = () => {
    setShowModal(true);
    setModalTitle(
      `${getI18n('customerList.subscriberInformation.edit')}${
        parameterType == 'Subscriber'
          ? getI18n('customerList.subscriberInformation.subscriberInformation')
          : getI18n('customerList.subscriberInformation.customerInformation')
      }`,
    );
    setModalContent(
      <CustomerInfoModal
        fields={customerInfoFields}
        onCancel={() => setShowModal(false)}
        onConfirm={saveCustomerInfo}></CustomerInfoModal>,
    );
  };
  console.log('customerInfoFields', customerInfoFields);
  return (
    <div className={css.itemBlock}>
      <SectionWrapper
        titleClassName={css.titleContainer}
        containerClassName={`${css.informationContainer} ${css.wrapperContainer}`}
        title={
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <span>
              {parameterType == 'Subscriber'
                ? getI18n(
                    'customerList.subscriberInformation.subscriberInformation',
                  )
                : getI18n(
                    'customerList.subscriberInformation.customerInformation',
                  )}
            </span>
            <VisibilityToggle defaultVisible={false} onToggle={setShow} />
          </div>
        }>
        <div>
          {customerInfoFields.map((item, index) => {
            const fieldName = _.get(item, 'field.name', '');
            const _fieldValue = (_.get(item, 'value', []) || []).join(' ');
            const optionI18nKey = OptionKeyMapping[_fieldValue];
            const fieldValue = optionI18nKey
              ? getI18n(optionI18nKey)
              : _fieldValue;
            const fieldType = _.get(item, 'field.fieldType');
            const isAreaCodeMobileNumber =
              fieldType === EnumFieldType.AreaCodeMobileNumber;
            if (isAreaCodeMobileNumber) {
              const areaCodeUuid = _.get(item, 'value.0');
              const mobile = _.get(item, 'value.1');
              return (
                <div className={css.item} key={index}>
                  <span>{getI18n(FiledNameKeyMapping[fieldName])}</span>
                  <span>
                    +
                    <AreaCodeDisplay
                      uuid={areaCodeUuid}
                      ContainerComp={React.Fragment}
                    />{' '}
                    {show ? mobile : maskPhone(mobile)}
                  </span>
                </div>
              );
            } else {
              return (
                item.field && (
                  <div className={css.item} key={index}>
                    <span>{getI18n(FiledNameKeyMapping[fieldName])}</span>
                    {show
                      ? fieldValue
                      : fieldValueGenerator(
                          fieldName,
                          customerInfoFields,
                          fieldValue,
                          fullNameAutoPopulate,
                          true,
                        )}
                  </div>
                )
              );
            }
          })}
        </div>
        <div className={css.editBtn}>
          <Button
            type='primary'
            ghost
            onClick={editInformation}
            disabled={!edit_customer_info}>
            {getI18n('customerList.subscriberInformation.edit')}
          </Button>
        </div>
      </SectionWrapper>
    </div>
  );
};

export default SubscriberInformation;
